// extracted by mini-css-extract-plugin
export default {"welcome":"welcome_welcome__CmLA+","welcomeLeft":"welcome_welcomeLeft__yKDDF","logo":"welcome_logo__LtJqH","robot":"welcome_robot__Ziw7r","welcomeRight":"welcome_welcomeRight__n1Gfq"};